import { Box } from "@mui/material";
import "./grid-wrapper.scss";
import Typography from "../../typography/typography";
import images from "../../../assets/images"
import ErpLoader from "../../loaders/erp-loader";

interface GridWrapperProps {
  children: React.ReactNode;
  data?: any[]
  isLoading?: boolean
}

const GridWrapper = (props: GridWrapperProps) => {
  const { children, data, isLoading } = props;
  return (
    <>
    {isLoading 
      ? 
        <ErpLoader/> 
      :
        <>
          {data?.length 
            ? 
              <div className="grid-wrapper">{children}</div>
            : 
              <Box position="fixed" left='50%' top="50%" transform="translate(-50%, -50%)">
                <img src={images.common.tableNoData} />
                <Typography color='theme.secondary.1000' weight="medium" align="center">No data</Typography>
              </Box>
          }
        </>
    }
    </>
  );
};

export { GridWrapper };
export default GridWrapper;
